module.exports = "file-word"